( function( $ ) {

    $(document).ready( function() {

        if ($('.wp-block-st-rotating-headline').length > 0) {

            var animationDelay = 2000;

            initHeadline();


            function initHeadline() {
                //initialise headline animation
                animateHeadline($('.rotating-line'));
            }


            function animateHeadline($headlines) {
                var duration = animationDelay;
                $headlines.each(function(){
                    var headline = $(this);
                    //trigger animation
                    setTimeout(function(){ hideWord( headline.find('.is-visible').eq(0) ) }, duration);
                });
            }

            function hideWord($word) {
                var nextWord = takeNext($word);

                switchWord($word, nextWord);
                setTimeout(function(){ hideWord(nextWord) }, animationDelay);
                
            }


            function takeNext($word) {
                return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
            }

            function switchWord($oldWord, $newWord) {
                $oldWord.removeClass('is-visible').addClass('is-hidden');
                $newWord.removeClass('is-hidden').addClass('is-visible');
            }

        }

    } );

} )( jQuery );
